(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import FormContact from './form-contact';
import mosaic from '../assets/static/mosaic.png';
import ImageWebp from '../components/custom/ImageWebp';
import { NEXT_PUBLIC_PHONE_COMPANY, NEXT_PUBLIC_ADDRESS_COMPANY, NEXT_PUBLIC_CITY_COMPANY, NEXT_PUBLIC_ZIPCODE_COMPANY } from '../utils/utilities';

class Footer extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
      className: "rowfooter"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 6,
      className: "info"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/logo.png",
      alt: "The District",
      className: "mb-5",
      width: "270",
      height: "65"
    }), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center dflexfooter mb-4"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("address", null, NEXT_PUBLIC_ADDRESS_COMPANY, ", ", /*#__PURE__*/React.createElement("br", null), NEXT_PUBLIC_CITY_COMPANY, ", ", NEXT_PUBLIC_ZIPCODE_COMPANY), /*#__PURE__*/React.createElement("p", null, "Phone: ", NEXT_PUBLIC_PHONE_COMPANY), /*#__PURE__*/React.createElement("p", {
      className: "mb-0"
    }, "Contact Hours", /*#__PURE__*/React.createElement("br", null), "Monday \u2013 Friday 10 AM to 5 PM", /*#__PURE__*/React.createElement("br", null), "Saturday & Sunday Closed")), /*#__PURE__*/React.createElement("div", {
      className: "devby text-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "mb-0"
    }, "Developed and Managed by:"), /*#__PURE__*/React.createElement(ImageWebp, {
      src: mosaic,
      alt: "Mosaic Student Communities",
      width: "148",
      height: "123"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6,
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/floorplans",
      className: "btn btn-secondary btn-block"
    }, "Apply Now")), /*#__PURE__*/React.createElement(Col, {
      sm: 6,
      className: "mb-3"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://mosaicstudent.appfolio.com/connect/users/sign_in?a=cw&utm_source=apmsites_v3&utm_campaign=pay_rent_button",
      target: "_blank",
      className: "btn btn-secondary btn-block",
      rel: "noopener"
    }, "Pay Rent", /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, " (opens in new window)")))), /*#__PURE__*/React.createElement("a", {
      href: "https://mosaicstudent.appfolio.com/connect/users/sign_in?a=cw&utm_source=apmsites_v3&utm_campaign=tportal_login",
      target: "_blank",
      className: "btn btn-secondary btn-block",
      rel: "noopener"
    }, "Maintenance Request", /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, " (opens in new window)"))), /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement("h2", {
      className: "h2"
    }, "Contact Us"), /*#__PURE__*/React.createElement(FormContact, null))), /*#__PURE__*/React.createElement(Row, {
      className: "footer-logos"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement("a", {
      href: "/web-accessibility"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/certified-wcag.png",
      alt: "Web Accessibility logo",
      title: "Compliant and certified for web content accessibility WCAG 2.0 and 2.1",
      width: 196,
      height: 46
    })), /*#__PURE__*/React.createElement("img", {
      src: "/images/equal-housing-opportunity.png",
      alt: "Equal housing oportunities",
      width: 148,
      height: 43
    })), /*#__PURE__*/React.createElement(Col, {
      as: "ul",
      md: 6,
      className: "nav-footer"
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/sitemap"
    }, "Sitemap (HTML)")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/sitemap.xml",
      target: "_blank",
      rel: "noreferrer"
    }, "Sitemap (XML)"))))), /*#__PURE__*/React.createElement("div", {
      className: "lastfooter"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: "https://it49.com/student-housing-web-design",
      target: "_blank",
      rel: "noopener"
    }, "Student Housing Web Design by IT49 Multimedia", /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, " (opens in new window)")))));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Footer;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Footer, "Footer", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Footer.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/Footer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();